import cn from 'classnames';
import styles from './PaginationTabs.module.scss';
import { Palettes } from '@/types';
import { useRouter } from 'next/router';

type PaginationTabsProps = {
  tabs: {
    text: string;
    link: string;
    onClick?: () => void;
    palette?: Palettes;
  }[];
  className?: string;
};

export function PaginationTabs({ tabs, className }: PaginationTabsProps) {
  const wrapperClassName = cn(styles.wrapper, className);
  const router = useRouter();

  const handleClick = (link: string, onClick?: () => void) => {
    if (router.pathname === link) {
      return;
    }
    if (onClick) onClick();
    router.push(link);
  };

  return (
    <div className={wrapperClassName}>
      {tabs.map((tab) => (
        <div
          key={tab.text}
          onClick={() => handleClick(tab.link, tab.onClick)}
          className={`${styles.tab} 
            ${tab.palette === Palettes.Primary ? styles.primary : ''}
            ${router.pathname === tab.link ? styles.active : ''}`}
        >
          {tab.text}
        </div>
      ))}
    </div>
  );
}
